import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import { Route, Switch, Redirect } from 'react-router-dom';
import { CHANGE_USER_DATA, CHANGE_USER_PASSWORD } from '../../redux/UserData';
import SettingsForm from './SettingsForm/SettingsForm';
import ManageAccountForm from './ManageAccountForm/ManageAccountForm';

class SettingsContainer extends PureComponent {
  handleSubmit = (values) => {
        return new Promise((resolve, reject) => {
      this.props.changeUserData({ dealer: values, promise: { resolve, reject } });
    });
  };

  handleManageSubmit = (values) => {
    return new Promise((resolve, reject) => {
      this.props.changeUserPassword({ dealer: values, promise: { resolve, reject } });
    });
  }

  render() {
    const { userData } = this.props;
    const initialValues = pick(userData, [
      'first_name', 'last_name', 'nickname', 'phone', 'company_name', 'ftin', 'avatar', 'second_phone', 'street', 'place', 'zip_code'
    ]);
    return (
      <Switch>
        <Redirect from="/dashboard/settings" exact to="/dashboard/settings/general" />
        <Route exact path="/dashboard/settings/general">
          <SettingsForm
            onSubmit={this.handleSubmit}
            userData={userData}
            initialValues={initialValues}
          />
        </Route>
        <Route exact path="/dashboard/settings/manage">
          <ManageAccountForm
            onSubmit={this.handleManageSubmit}
          />
        </Route>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: get(state, 'userData'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeUserData: changedData => dispatch(CHANGE_USER_DATA(changedData)),
    changeUserPassword: changedData => dispatch(CHANGE_USER_PASSWORD(changedData)),
  };
};

SettingsContainer.propTypes = {
  changeUserData: PropTypes.func.isRequired,
  changeUserPassword: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    street: PropTypes.string,
    place: PropTypes.string,
    zip_code: PropTypes.string,
    company_name: PropTypes.string,
    first_name: PropTypes.string,
    ftin: PropTypes.string,
    last_name: PropTypes.string,
    nickname: PropTypes.string,
    phone: PropTypes.string,
    second_phone: PropTypes.string,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);
